<template>
  <div v-if="visible" class="app-watermark" aria-hidden="true">
    <div class="app-watermark-layer" :style="layerStyle" />
  </div>
</template>

<script>
function pad(n) {
  return n < 10 ? '0' + n : String(n)
}

function formatNow(date) {
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate())
  ].join('-') + ' ' + [
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds())
  ].join(':')
}

function buildWatermarkDataUrl(line1, line2) {
  const canvas = document.createElement('canvas')
  const width = 320
  const height = 160
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''

  ctx.clearRect(0, 0, width, height)
  ctx.translate(width / 2, height / 2)
  ctx.rotate((-22 * Math.PI) / 180)
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = 'rgba(0, 0, 0, 0.07)'
  ctx.font = '14px -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif'
  ctx.fillText(line1, 0, -10)
  ctx.fillText(line2, 0, 14)
  return canvas.toDataURL('image/png')
}

export default {
  name: 'AppWatermark',
  props: {
    userName: { type: String, default: '' },
    visible: { type: Boolean, default: true }
  },
  data() {
    return {
      nowText: formatNow(new Date()),
      layerStyle: { backgroundImage: 'none' },
      timer: null
    }
  },
  watch: {
    userName() {
      this.refreshLayer()
    }
  },
  mounted() {
    this.refreshLayer()
    this.timer = window.setInterval(() => {
      this.nowText = formatNow(new Date())
      this.refreshLayer()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    refreshLayer() {
      const name = this.userName || '未知用户'
      const line1 = '当前登录：' + name
      const dataUrl = buildWatermarkDataUrl(line1, this.nowText)
      this.layerStyle = {
        backgroundImage: 'url("' + dataUrl + '")'
      }
    }
  }
}
</script>

<style scoped>
.app-watermark {
  position: fixed;
  inset: 0;
  z-index: 999;
  pointer-events: none;
  overflow: hidden;
}

.app-watermark-layer {
  width: 100%;
  height: 100%;
  background-repeat: repeat;
  background-size: 320px 160px;
}
</style>
